import { Pipe, PipeTransform } from '@angular/core';
import { ApiMessagingHelperService } from './messaging-helper.service';
import { ucFirst } from '../helpers/function/uc-first';

@Pipe({
  name: 'apiMessaging',
})
export class ApiMessagingHelperPipe implements PipeTransform {
  constructor(private _apiMessagingHelperSrv: ApiMessagingHelperService) {}

  transform(messaging: any, ...args: any[]): any {
    const [fct] = args;
    args.shift();
    return (this._apiMessagingHelperSrv as any)['get' + ucFirst(fct)](
      messaging,
      ...args
    );
  }
}

@Pipe({
  name: 'apiMessagingU',
  pure: false,
})
export class ApiMessagingHelperUnPurePipe
  extends ApiMessagingHelperPipe
  implements PipeTransform {}
